// src/store.js
import { create } from "zustand";

const useStore = create((set) => ({
  currentLine: null,
  setCurrentLine: (line) => set({ currentLine: line }),
}));

export default useStore;
